import { useTranslation } from "next-i18next";
import Image from "next/image";
import React from "react";

function EmailServices() {
  const { t } = useTranslation(["common", "homepage", "email"]);

  return (
    <div className="relative p-5 services bg-makdosSecondaryGray lg:p-28">
      <div className="absolute 2xl:left-72 2xl:top-12 lg:left-12 lg:top-14 z-1">
        <Image src={"/mask.png"} alt="mask" title="email" width={184} height={184} />
      </div>

      <div className="absolute 2xl:right-72 2xl:bottom-20 lg:right-14 lg:bottom-24 z-1">
        <Image src={"/mask.png"} alt="mask" title="email" width={184} height={184} />
      </div>

      <div className="container grid grid-cols-4 gap-10 mx-auto mb-10 ">
        <div
          className="z-10 col-span-4 transition-all duration-500 bg-white border-b-4 border-transparent rounded-md shadow-lg cursor-pointer servicesCard group lg:col-span-1 hover:border-makdosYellow hover:border-b-4 hover:shadow-2xl">
          <div className="p-10 pb-10 rounded-sm servicesCardContent">
            <div className="relative w-12 h-12 rounded-full bg-makdosYellow">
              <i className="absolute text-5xl top-3 -right-3 ri-shield-check-line" />
            </div>
            <h3 className="mt-5 mb-4 text-lg font-semibold">{t("email:servicesBoxTitle1")}</h3>
            <div className="text-sm text-cardText" dangerouslySetInnerHTML={{ __html: t("email:servicesBoxDescription1") }}></div>
          </div>
        </div>

        <div
          className="col-span-4 transition-all duration-500 bg-white border-b-4 border-transparent rounded-md shadow-lg cursor-pointer servicesCard group lg:col-span-1 hover:border-makdosYellow hover:border-b-4 hover:shadow-2xl">
          <div className="p-10 pb-10 rounded-sm servicesCardContent">
            <div className="relative w-12 h-12 rounded-full bg-makdosYellow">
              <i className="absolute text-5xl top-3 -right-3 ri-hard-drive-line" />
            </div>
            <h3 className="mt-5 mb-4 text-lg font-semibold">{t("email:servicesBoxTitle2")}</h3>
            <div className="text-sm text-cardText" dangerouslySetInnerHTML={{ __html: t("email:servicesBoxDescription2") }}></div>
          </div>
        </div>

        <div
          className="col-span-4 transition-all duration-500 bg-white border-b-4 border-transparent rounded-md shadow-lg cursor-pointer servicesCard group lg:col-span-1 hover:border-makdosYellow hover:border-b-4 hover:shadow-2xl">
          <div className="p-10 pb-10 rounded-sm servicesCardContent">
            <div className="relative w-12 h-12 rounded-full bg-makdosYellow">
              <i className="absolute text-5xl top-3 -right-3 ri-device-line" />
            </div>
            <h3 className="mt-5 mb-4 text-lg font-semibold">{t("email:servicesBoxTitle3")}</h3>
            <p className="text-sm text-cardText" dangerouslySetInnerHTML={{ __html: t("email:servicesBoxDescription3") }}></p>
          </div>
        </div>

        <div
          className="col-span-4 transition-all duration-500 bg-white border-b-4 border-transparent rounded-md shadow-lg cursor-pointer servicesCard group lg:col-span-1 hover:border-makdosYellow hover:border-b-4 hover:shadow-2xl">
          <div className="p-10 pb-10 rounded-sm servicesCardContent">
            <div className="relative w-12 h-12 rounded-full bg-makdosYellow">
              <i className="absolute text-5xl top-3 -right-3 ri-customer-service-2-line" />
            </div>
            <h3 className="mt-5 mb-4 text-lg font-semibold">{t("email:servicesBoxTitle4")}</h3>
            <p className="text-sm text-cardText">{t("email:servicesBoxDescription4")}</p>
          </div>
        </div>
      </div>

      <div className="container grid grid-cols-4 gap-10 mx-auto mb-10">
        <div
          className="col-span-4 transition-all duration-500 bg-white border-b-4 border-transparent rounded-md shadow-lg cursor-pointer servicesCard group lg:col-span-1 hover:border-makdosYellow hover:border-b-4 hover:shadow-2xl">
          <div className="p-10 pb-10 rounded-sm servicesCardContent">
            <div className="relative w-12 h-12 rounded-full bg-makdosYellow">
              <i className="absolute text-5xl top-3 -right-3 ri-mail-forbid-line" />
            </div>
            <h3 className="mt-5 mb-4 text-lg font-semibold">{t("email:servicesBoxTitle5")}</h3>
            <div className="text-sm text-cardText" dangerouslySetInnerHTML={{ __html: t("email:servicesBoxDescription5") }}></div>
          </div>
        </div>

        <div
          className="col-span-4 transition-all duration-500 bg-white border-b-4 border-transparent rounded-md shadow-lg cursor-pointer servicesCard group lg:col-span-1 hover:border-makdosYellow hover:border-b-4 hover:shadow-2xl">
          <div className="p-10 pb-10 rounded-sm servicesCardContent">
            <div className="relative w-12 h-12 rounded-full bg-makdosYellow">
              <i className="absolute text-5xl top-3 -right-3 ri-history-line" />
            </div>
            <h3 className="mt-5 mb-4 text-lg font-semibold">{t("email:servicesBoxTitle6")}</h3>
            <div className="text-sm text-cardText" dangerouslySetInnerHTML={{ __html: t("email:servicesBoxDescription6") }}></div>
          </div>
        </div>

        <div
          className="col-span-4 transition-all duration-500 bg-white border-b-4 border-transparent rounded-md shadow-lg cursor-pointer servicesCard group lg:col-span-1 hover:border-makdosYellow hover:border-b-4 hover:shadow-2xl">
          <div className="p-10 pb-10 rounded-sm servicesCardContent">
            <div className="relative w-12 h-12 rounded-full bg-makdosYellow">
              <i className="absolute text-5xl top-3 -right-3 ri-mail-unread-line" />
            </div>
            <h3 className="mt-5 mb-4 text-lg font-semibold">{t("email:servicesBoxTitle7")}</h3>
            <div className="text-sm text-cardText" dangerouslySetInnerHTML={{ __html: t("email:servicesBoxDescription7") }}></div>
          </div>
        </div>

        <div
          className="z-10 col-span-4 transition-all duration-500 bg-white border-b-4 border-transparent rounded-md shadow-lg cursor-pointer servicesCard group lg:col-span-1 hover:border-makdosYellow hover:border-b-4 hover:shadow-2xl">
          <div className="p-10 pb-10 rounded-sm servicesCardContent">
            <div className="relative w-12 h-12 rounded-full bg-makdosYellow">
              <i className="absolute text-5xl top-3 -right-3 ri-bar-chart-box-line" />
            </div>
            <h3 className="mt-5 mb-4 text-lg font-semibold">{t("email:servicesBoxTitle8")}</h3>
            <div className="text-sm text-cardText" dangerouslySetInnerHTML={{ __html: t("email:servicesBoxDescription8") }}></div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default EmailServices;
